import { Col, message, Row } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createReplacementTransportOption } from "../../../../lib/api/resources/replacementTransports";
import {
  ReplacementTransportOptionFormCard,
  ReplacementTransportOptionInputDto,
} from "./components/ReplacementTransportOptionFormCard";

export const ReplacementTransportOptionCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createReplacementTransportOptionMutation = useMutation({
    mutationFn: (data: ReplacementTransportOptionInputDto) =>
      createReplacementTransportOption(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["replacementTransportOptions"],
      });
      message.success("Vervangend vervoer optie succesvol aangemaakt");
      navigate("/replacement-transport/options");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van de vervangend vervoer optie",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <ReplacementTransportOptionFormCard
          mutation={createReplacementTransportOptionMutation}
        />
      </Col>
    </Row>
  );
};
